/* unplugin-vue-components disabled */// extracted by css-extract-rspack-plugin
export default {"container":"index_container__ReOb8"};